'use client';

import React from 'react';
import styles from './index.module.scss';
import { Montserrat } from 'next/font/google';
import { useTranslations } from 'next-intl';
import Image from 'next/image';
import AnimatedHeadings from '@components/AnimatedHeadings';
import AnimatedParagraphs from '@components/AnimatedParagraphs';
import AboutUs from '@public/aboutUs.jpg';
import AboutUsMobile from '@public/aboutUs3.jpg';

const montserrat = Montserrat({ subsets: ['latin'] });

const About = () => {
  const t = useTranslations('about');
  return (
    <div
      className={`${styles.container}  ${montserrat.className}`}
      data-id={'about'}
      id={'about'}
    >
      <div className={styles.wrapper}>
        <AnimatedHeadings el="h1" text={t('heading')} repeatDelay={10000} />
        <AnimatedParagraphs className="mt-5 text-base sm:text-lg md:text-xl">
          {t('description')}
        </AnimatedParagraphs>

        <Image
          className={styles.image}
          src={AboutUsMobile.src}
          alt="team"
          sizes="100vw"
          style={{
            width: '100%',
            height: 'auto',
          }}
          width={272}
          height={92}
        />

        <div className={styles.group}>
          <div>
            <AnimatedHeadings
              el="h2"
              text={t('subHeading1')}
              repeatDelay={10000}
            />
            <AnimatedParagraphs className={styles.offer}>
              {t('subDescription1')}
            </AnimatedParagraphs>
          </div>
          <div>
            <AnimatedHeadings
              el="h2"
              text={t('subHeading2')}
              repeatDelay={10000}
            />
            <AnimatedParagraphs className={styles.help}>
              {t('subDescription2')}
            </AnimatedParagraphs>
          </div>
        </div>
        <div className={styles.group}>
          <div>
            <AnimatedHeadings
              el="h2"
              text={t('subHeading3')}
              repeatDelay={10000}
            />

            <AnimatedParagraphs className={styles.help}>
              {t('subDescription3')}
            </AnimatedParagraphs>
          </div>
          <div>
            <AnimatedHeadings
              el="h2"
              text={t('subHeading4')}
              repeatDelay={10000}
            />

            <AnimatedParagraphs className={styles.mission}>
              {t('subDescription4')}
            </AnimatedParagraphs>
          </div>
        </div>
      </div>
      <Image
        className={styles.image2}
        src={AboutUs.src}
        alt="team"
        width={400}
        height={300}
      />
    </div>
  );
};

export default About;
